"use client";

import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollSmoother, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(useGSAP, ScrollTrigger, ScrollSmoother);
export function SmoothScroll() {
  useGSAP(_temp);
  return null;
}
function _temp() {
  ScrollSmoother.create({
    wrapper: "#smooth-wrapper",
    content: "#smooth-content",
    smooth: 1.2,
    smoothTouch: false,
    effects: true,
    normalizeScroll: {
      allowNestedScroll: true
    },
    ignoreMobileResize: true
  });
}